import { render, staticRenderFns } from "./ReviewSection.vue?vue&type=template&id=3b810ddf&scoped=true&"
import script from "./ReviewSection.vue?vue&type=script&lang=js&"
export * from "./ReviewSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b810ddf",
  null
  
)

export default component.exports